import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { HomePageSectionTypes, ImageAccessibility, ImageTypes, LaymanHomePageSectionTypes, SourceKey, SourceNameKey } from "@vc-workspace/utils-constants";
import { convertToTitleCase } from "@vc-workspace/utils-formatters";
import { getImagesByType } from "@vc-workspace/utils-helpers";
import { Typography } from "@vc-workspace/utils-typography";
import Link from "next/link";
import { listContainer, listItemContainer, listItemImage } from './category-collection-group.module.style';
/* eslint-disable-next-line */

function getRedirectUrl(itemEntry, sectionTitle) {
  var redirectUrl = "";

  switch (itemEntry.type) {
    case 'CATEGORY':
      redirectUrl = "/category/".concat(itemEntry.slug);
      break;

    case HomePageSectionTypes.SIA_COLLECTION:
      redirectUrl = "/collection/".concat(itemEntry.slug, "/").concat(itemEntry.usId);
      break;
  }

  if (redirectUrl) {
    redirectUrl = redirectUrl + "?".concat(SourceKey, "=").concat(LaymanHomePageSectionTypes.CATEGORY_SIA_COLLECTION_GROUP, "&").concat(SourceNameKey, "=").concat(sectionTitle);
  }

  return redirectUrl;
}

export function CategoryCollectionGroup(props) {
  return _jsxs("div", {
    className: props.context.isMobileView ? "pt-8" : "pt-16",
    children: [_jsx("div", {
      className: "page-cushion-container",
      children: !props.hideTitle ? _jsx(Typography, {
        type: props.context.isMobileView ? "SubHeading1" : "Headline_H2",
        color: "prussian_blue",
        className: "pb-4",
        extra_bold: true,
        children: convertToTitleCase(props.data.title)
      }) : null
    }), _jsx("div", {
      css: listContainer,
      className: "page-cushion-container--left",
      children: props.data.data.entries.map(function (entry) {
        var displayImage = getImagesByType(entry.images, ImageTypes.Card, "2", props.context.isMobileView ? ImageAccessibility.Mobile : ImageAccessibility.Desktop);
        return _jsx(Link, {
          href: getRedirectUrl(entry, props.data.title),
          passHref: true,
          children: _jsxs("a", {
            css: listItemContainer,
            children: [_jsxs("picture", {
              children: [_jsx("source", {
                srcSet: displayImage.webP,
                type: "image/webp"
              }), _jsx("img", {
                src: displayImage.url,
                css: listItemImage
              })]
            }), _jsx(Typography, {
              type: props.context.isMobileView ? "Body2" : "Body1",
              color: "nero",
              className: "text-center pt-2 whitespace-normal",
              semi_bold: true,
              children: entry.title
            })]
          })
        }, entry.slug);
      })
    })]
  });
}
export default CategoryCollectionGroup;